import {z} from 'zod';

export const recommendationSchema = z.object({
    html: z.string(),
});

export type Recommendation = z.infer<typeof recommendationSchema>;
